// src/pages/SizeGuidePage.tsx
// Standalone /size-guide page. The content itself is the reusable <SizeGuide />
// (also shown in a modal on the product page).

import React, { useEffect } from "react";
import PageContainer, { GapSize } from "../components/PageContainer";
import PageSection from "../components/PageSection";
import SizeGuide from "../components/SizeGuide";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

const SizeGuidePage: React.FC = () => {
  useDocumentMeta({
    title: "Size Guide",
    description:
      "Find your fit at The Americana Company — unisex apparel measurements and women's-fit guidance so you order the right size the first time.",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer hasPadding gapSize={GapSize.Small}>
      <PageSection className="flex justify-center py-4">
        <div className="max-w-3xl w-full">
          <SizeGuide fit="all" />
        </div>
      </PageSection>
    </PageContainer>
  );
};

export default SizeGuidePage;
